<template>
  <v-layout row wrap white pl-5>
    <v-flex xs3 pr-4>
      <v-text-field
        v-model="document"
        label="CPF/CNPJ do condomínio"
        :mask="
          document.length <= 11 ? '###.###.###-########' : '##.###.###/####-##'
        "
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>

    <v-flex xs4>
      <v-text-field
        v-model="name"
        label="Nome do condomínio"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>

    <v-flex xs12 text-xs-left>
      <v-switch
        color="success"
        class="pt-0 mt-0 smallSwitch"
        v-model="showInactiveCondominiuns"
        label="Exibir os condomínios inativos"
      ></v-switch>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'SearchCondominiums',

  props: {
    searchCondominiums: Function
  },

  data () {
    return {
      showInactiveCondominiuns: false,
      document: '',
      name: ''
    }
  },

  methods: {
    search () {
      this.searchCondominiums({
        document: this.document,
        name: this.name,
        flag_active: this.showInactiveCondominiuns
      })
    }
  }
}
</script>

<style>
</style>
